<template>
  <div>
      <div class="choice" :style="{height:fullpage + 'px'}"> 
          <div class="choice-a">
              <router-link :to="{ name:'product-category' }" class="choice-truck" >
                  <span>卡车</span>
              </router-link>
              <router-link :to="{ name:'product-select', params: { cate: '2' }}"  class="choice-car">
                  <span>轿车</span>
              </router-link>
          </div>
      </div>
  </div>
</template>
<script>
    export default{
        data(){
            return{
              fullpage:document.documentElement.clientHeight,
              video_class:[],
              type:this.$store.state.type
            }
        },
        computed:{
            step(){
                return this.$route.query.step
            }
        },
        watch:{
            'type'(cur,old){
                this.$store.commit('setType',cur)
                this.getVideoClass()
            }
        },
        mounted(){
            this.getVideoClass()
        },
        methods:{
            getVideoClass(){
                this.$axios.get('netusers/videocate',{params:{type:this.type}})
                .then(
                    res=>{
                        this.video_class=res.data.data.data
                    }
                )
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/mobile/tation/choicegab.vue